export default __webpack_public_path__ + "static/media/down_white.f22a8fb2.svg";